import "./assets/tailwind.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";

import { useAuthStore } from "./stores/authStore.js";
import { useUsersStore } from "./stores/usersStore.js";
import { useRegistrationStore } from "./stores/registrationStore.js";
import { useEventsStore } from "./stores/eventsStore.js";

async function initApp() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);

  // Initialize stores
  const authStore = useAuthStore();
  const usersStore = useUsersStore();
  const registrationStore = useRegistrationStore();
  const eventsStore = useEventsStore();

  // Provide stores to the app
  app.provide("authStore", authStore);
  app.provide("usersStore", usersStore);
  app.provide("registrationStore", registrationStore);
  app.provide("eventsStore", eventsStore);

  // Initialize auth state
  await authStore.initAuth();

  if (document.getElementById("app")) {
    app.mount("#app");
  } else {
    console.error("Mounting point #app not found");
  }

  return app;
}

// Check if the wpData object is available
if (typeof wpData !== 'undefined') {
  // If wpData is available, initialize the app
  initApp();
} else {
  // If wpData is not available, wait for it to be defined
  Object.defineProperty(window, 'wpData', {
    configurable: true,
    set: function(value) {
      delete window.wpData;
      window.wpData = value;
      initApp();
    }
  });
}